export const SimilarityInstanceType = {
    'SIMILARITY': 'similarity',
    'ELASTICSEARCH': 'elasticsearch',
    'OPENSEARCH': 'opensearch',
};
